import type { Stripe } from '@stripe/stripe-js';
import { createContext } from 'react';

import type {
  CardInfo,
  DynamicQuestionPayload,
  FetchDataFunction,
  Guests,
  GuestsRequest,
  MewsReservation,
  MewsReservationResponse,
} from '../../interfaces';

interface ApiEnvelop {
  requestId: string;
  responseTimeMs: number;
}
interface SuccessEnvelop<T = unknown> extends ApiEnvelop {
  result: T;
}

export interface GuestPortalContextProps {
  reservation?: MewsReservation;
  getMewsReservations: FetchDataFunction<MewsReservationResponse>;
  loadingReservation: boolean;

  loading: boolean;
  error: Error | null;
  preregisteredGuest?: GuestsRequest;
  getGuestPreregistered: FetchDataFunction<GuestsRequest>;

  guestName: string;
  setGuestName: React.Dispatch<React.SetStateAction<string>>;
  addPackageResult?: SuccessEnvelop<GuestsRequest>;
  addPackageToGuest: FetchDataFunction<GuestsRequest>;
  loadingAddPackage: boolean;

  addPackageError: Error | null;
  cardInfo?: CardInfo;
  cardInfoLoading: boolean;
  getCardInfo: FetchDataFunction<CardInfo>;
  getGuest: FetchDataFunction<Guests>;
  guestData?: Guests;

  dynamicQuestionsData: DynamicQuestionPayload[];

  reservationRating: number;
  loadingReservationRating: boolean;

  stripePromise: Promise<Stripe | null>;
}

export const GuestPortalContext = createContext<GuestPortalContextProps | undefined>(
  undefined,
);
